<template>
  <div class="function-wrapper">
    <icon
      @click.native="submitN(1)"
      class="my-icon"
      name="icon-jia1"
      size="25"
      color="#00a4ff"
      :other="iconStyle"
      title="添加模态框"
    />
    <icon
      @click.native="submitN(2)"
      class="my-icon"
      :class="{ active: isDel }"
      name="icon-shanchu3"
      size="25"
      color="#00a4ff"
      :other="iconStyle"
      title="删除"
    />
    <icon
      @click.native="submitN(3)"
      class="my-icon"
      :class="{ active: border }"
      name="icon-a-zhengfangxingfuxuankuang"
      size="25"
      color="#00a4ff"
      :other="iconStyle"
      title="边框"
    />
    <icon
      @click.native="submitN(4)"
      class="my-icon"
      name="icon-tupian3"
      size="25"
      color="#00a4ff"
      :other="iconStyle"
      title="背景"
    />
    <icon
      @click.native="submitN(5)"
      class="my-icon"
      :class="{ active: prior }"
      name="icon-cengji2"
      size="25"
      color="#00a4ff"
      :other="iconStyle"
      title="层级"
    />
    <icon
      @click.native="submitN(6)"
      class="my-icon"
      name="icon-baocun3"
      size="25"
      color="#409eff"
      :other="iconStyle"
      title="保存"
    />
    <icon
      @click.native="submitN(7)"
      class="my-icon"
      name="icon-scene"
      size="25"
      color="#409eff"
      :other="iconStyle"
      title="跳转保存的场景"
    />
  </div>
</template>

<script>
import icon from "./icon.vue";
export default {
  name: "domain-menu",
  components: {
    icon,
  },
  props: ["isDel","border","prior"],
  data() {
    return {
      iconStyle: {
        height: "25px",
        lineHeight: "25px",
        width: "100%",
        textAlign: "center",
        padding: "2px 0",
        borderTop: "1px solid #fff",
      },
    };
  },
  methods: {
    submitN(n) {
        this.$emit("funcHandle",n)
    }
  }
};
</script>

<style lang="scss" scoped>
.function-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .my-icon {
    cursor: pointer;
    transition: all 0.3s linear;
    &:hover {
      color: #fff !important;
      background-color: #409eff;
    }
    &.active {
      color: #fff !important;
      background-color: #409eff;
    }
  }
}
</style>
